export const UPDATE_INVENTORY = '/subscription_company'
